module.exports = __webpack_public_path__ + "img/gallery_layout3.ab85b144.png";